import * as React from 'react';
import { clsx } from 'clsx';
import * as styles from './styles.css';

export interface IPaginationItemProps extends React.PropsWithChildren {
  isActive?: boolean;

  onClick?(): void;
}

export const PaginationItem: React.FC<IPaginationItemProps> = props => {
  return (
    <div
      data-testid="pagination-item"
      className={clsx(styles['container'], {
        [styles['container-active']]: props.isActive,
      })}
      onClick={props.onClick}
    >
      <span className={styles['content']}>{props.children}</span>
    </div>
  );
};

PaginationItem.displayName = 'PaginationItem';
